import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ActivitePrestationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllActivitePrestation(): Observable<ActivitePrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activitePrestationUrl}/all`,
			'getAllActivitePrestation'
		);
	}

	importActivitePrestation(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'activitePrestation.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.activitePrestationUrl}/import`,
			`importActivitePrestation`,
			formData
		);
	}

	getActivitePrestationById(id: number): Observable<ActivitePrestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activitePrestationUrl}/get/${id}`,
			'getActivitePrestationById'
		);
	}

	getActivitePrestationByBonCommandeReference(bonCommandeReferenceId: number): Observable<ActivitePrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activitePrestationUrl}/getByBonCommandeReference/${bonCommandeReferenceId}`,
			'getActivitePrestationByBonCommandeReference'
		);
	}

	getByPrestation(prestationId: number): Observable<ActivitePrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activitePrestationUrl}/getByPrestation/${prestationId}`,
			'getActivitePrestationById'
		);
	}

	getByServiceAndRegionAndDates(serviceId: number, regionId: number, dateDebut: string, dateFin: string): Observable<ActivitePrestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.activitePrestationUrl}/getByServiceAndRegionAndDates/${serviceId}/${regionId}/${dateDebut}/${dateFin}`,
			'getByServiceAndRegionAndDates'
		);
	}

	updateActivitePrestation(activitePrestation: ActivitePrestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.activitePrestationUrl}/update/${activitePrestation.id}`,
			'updateActivitePrestation',
			activitePrestation
		);
	}

	addActivitePrestation(activitePrestation: ActivitePrestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.activitePrestationUrl}/add`,
			'addActivitePrestation',
			activitePrestation
		);
	}

	deleteActivitePrestation(activitePrestationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.activitePrestationUrl}/delete/${activitePrestationId}`,
			`deleteActivitePrestation`
		);
	}
}
